import { render } from "./Rectangle.vue?vue&type=template&id=353d3d69"
import script from "./Rectangle.vue?vue&type=script&lang=js"
export * from "./Rectangle.vue?vue&type=script&lang=js"

import exportComponent from "C:\\NicolPC\\VueWork2026\\Axxo\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__